import { DESIGN_TOKENS } from '@disqotech/vinyl-design-system/design-tokens';
import { DEVICE_BREAKPOINT, MOBILE_HEADER_HEIGHT, PARAGRAPH, TITLES_NORMAL } from 'Shared/styles/designConstants';
import styled from 'styled-components';

export const ContentContainer = styled.div`
  max-width: 414px;
  padding  : 40px 16px;
  margin   : 0 auto;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    margin-top: ${MOBILE_HEADER_HEIGHT};
  }
`;

export const MessageContainer = styled.p`
  ${PARAGRAPH.DEFAULT}
  color: ${DESIGN_TOKENS.color.text.secondary.value};
`;

export const ButtonContainer = styled.div`
  ${TITLES_NORMAL.FT_01}
  margin-top: 60px;

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    margin-top: 40px;
  }
`;

